import {
  WorkingHoursResponse,
  WorkingHoursStatus,
} from '../../../../../../../api/types/lecturers/working-hours/working-hours.type';
import React from 'react';

export const WorkingHoursStatusTemplate = (rowData: WorkingHoursResponse) => {
  const getStatusText = (status: WorkingHoursStatus) => {
    switch (status) {
      case WorkingHoursStatus.PendingForApproval:
        return 'ממתין לאישור';
      case WorkingHoursStatus.Approved:
        return 'מאושר';
      case WorkingHoursStatus.Suspended:
        return 'מושעה';
      default:
        return status;
    }
  };

  const getStatusSeverity = (status: WorkingHoursStatus) => {
    switch (status) {
      case WorkingHoursStatus.PendingForApproval:
        return 'warning';
      case WorkingHoursStatus.Approved:
        return 'success';
      case WorkingHoursStatus.Suspended:
        return 'danger';
      default:
        return 'info';
    }
  };

  return (
    <span className={`p-tag p-tag-${getStatusSeverity(rowData.status)}`}>
      {getStatusText(rowData.status)}
    </span>
  );
};
